import './style.css';
import { RouteManager } from './core/RouteManager';

// Extend the Window interface to include our routeManager
declare global {
  interface Window {
    routeManager?: RouteManager;
  }
}

async function init() {
  // Clean up existing routeManager if it exists (for HMR)
  if (window.routeManager) {
    window.routeManager.destroy();
    window.routeManager = undefined;
  }
  
  let app_container = document.getElementById('app');
  if (!app_container) {
    app_container = document.createElement('div');
    app_container.id = 'app';
    document.body.appendChild(app_container);
  }

  // Initialize the route manager which handles authentication and routing
  const routeManager = new RouteManager(app_container);
  
  // Store reference globally for debugging/access if needed
  window.routeManager = routeManager;
}

// Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    init().catch(console.error);
  });
} else {
  // DOM is already loaded (e.g., during HMR reload)
  init().catch(console.error);
}

// Handle Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    if (window.routeManager) {
      window.routeManager.destroy();
      window.routeManager = undefined;
    }
    // Re-initialize after cleanup
    init().catch(console.error);
  });
  
  import.meta.hot.dispose(() => {
    if (window.routeManager) {
      window.routeManager.destroy();
      window.routeManager = undefined;
    }
  });
}